import React, { useEffect } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import { getOrchestrator } from "@bookingcom/web-page-orchestrator";
import useEvents from "../../hooks/useEvents.js";
const OPT_IN_AA_COLLECTION_POINT = "web_sr_aa";
const OPT_IN_AA_CHECK_COMMAND = "CAPLA_EVENT_direct-marketing-component_OPT_IN_AA_CHECK";
const WRAPPER_READY_POLL_MS = 100;
const WRAPPER_READY_TIMEOUT_MS = 15000;
const OptInAANeetiTracker = () => {
    const { grumble } = useEvents();
    const { Component, isLoading, error } = useRemoteComponent({
        type: "capla",
        project: "direct-marketing",
        service: "rendering-service",
        path: "/OptInAAOrchestrator",
        options: {
            timeout: 5000
        }
    });
    useEffect(() => {
        if (isLoading || error)
            return;
        let cancelled = false;
        let pollTimeout;
        const startedAt = Date.now();
        const resolveOptInState = async () => {
            if (cancelled)
                return;
            const waitedMs = Date.now() - startedAt;
            const orchestrator = getOrchestrator();
            if (!orchestrator?.hasCommand(OPT_IN_AA_CHECK_COMMAND)) {
                if (waitedMs >= WRAPPER_READY_TIMEOUT_MS) {
                    grumble("OptInAA orchestrator: wrapper never became ready", {
                        waitedMs,
                        reason: orchestrator ? "command-not-registered" : "orchestrator-missing"
                    });
                    return;
                }
                pollTimeout = setTimeout(() => void resolveOptInState(), WRAPPER_READY_POLL_MS);
                return;
            }
            try {
                const result = await orchestrator.runCommand(OPT_IN_AA_CHECK_COMMAND, {
                    collectionPoint: OPT_IN_AA_COLLECTION_POINT
                });
                if (cancelled)
                    return;
                grumble("OptInAA orchestrator: RESOLVED", { result, waitedMs });
            }
            catch (err) {
                grumble("OptInAA orchestrator: CHECK failed", { error: err.toString() });
            }
        };
        void resolveOptInState();
        return () => {
            cancelled = true;
            clearTimeout(pollTimeout);
        };
    }, [isLoading, error, grumble]);
    useEffect(() => {
        if (!isLoading && error) {
            grumble("Remote component error: OptInAA orchestrator on SR page", { error: error.toString() });
        }
    }, [isLoading, error, grumble]);
    useEffect(() => {
        if (!isLoading && !error) {
            grumble("OptInAA orchestrator: remote component mounted");
        }
    }, [isLoading, error, grumble]);
    if (isLoading || error) {
        return null;
    }
    return React.createElement(Component, null);
};
export default OptInAANeetiTracker;
